import styled from 'styled-components';
import * as S from '../styled';

export const List = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: min-content min-content;
    grid-gap: 5vw;

    @media(max-width: ${S.breakePoints.mobile}) {
        grid-template-columns: 1fr;
        grid-template-rows: min-content;
        grid-gap: 35px;
    }
`;

export const ListItem = styled(S.ListItem)`
    align-items: center;

    @media(max-width: ${S.breakePoints.mobile}) {
        align-items: flex-start;
    }
`;

export const ImgWrap = styled(S.ImgWrap)`
    margin-bottom: 15px;
    height: 92px;

    @media(max-width: ${S.breakePoints.mobile}) {
        width: auto;
    }
`;

export const DataTitle = styled(S.DataTitle)`
    text-align: center;

    @media(max-width: ${S.breakePoints.mobile}) {
        text-align: left;
    }
`;

export const DataText = styled(S.DataText)`
    margin-bottom: 20px;
    text-align: center;

    @media(max-width: ${S.breakePoints.mobile}) {
        text-align: left;
    }
`;

export const DataLink = styled(S.DataLink)`
    margin-top: auto;
    text-align: center;
`;
